export default __webpack_public_path__ + "static/media/ip-tv-icon.2fe10694.png";